<template>
    <div class="place-self-center mb-32">
        <h2 class="font-semibold text-xl text-white text-center mt-5">
            Olá, {{ customer.name }}
        </h2>
        <div class="mx-5 text-left">
        <span class="text-sm leading-none text-gray-400">
            Você já realizou uma transação antes, deseja realizar um novo pagamento com seus dados já cadastrados? Ao prosseguir você confirma que é o verdadeiro proprietário dos dados a seguir:
        </span>
        </div>
        <div class="m-5">
            <div class="grid grid-cols-2 gap-6">
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="CPF"/>
                    <span class=" text-white text-sm break-all">{{ customer.federal_document }}</span>
                </div>
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="E-mail"/>
                    <span class=" text-white text-sm break-all">{{ customer.email }}</span>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-6 mt-2">
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Telefone"/>
                    <span class=" text-white text-sm break-all">{{ customer.phone_number }}</span>
                </div>
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Profissão"/>
                    <span class=" text-white text-sm break-all">{{ customer.occupation }}</span>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-6 mt-2">
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Rua"/>
                    <span class=" text-white text-sm break-all">{{ customer.address.street }}</span>
                </div>
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Número"/>
                    <span class=" text-white text-sm break-all">{{ customer.address.number }}</span>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-6 mt-2">
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Complemento"/>
                    <span class=" text-white text-sm break-all">{{ customer.address.complement }}</span>
                </div>
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Bairro"/>
                    <span class=" text-white text-sm break-all">{{ customer.address.neighborhood }}</span>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-6 mt-2">
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Cidade"/>
                    <span class=" text-white text-sm break-all">{{ customer.address.city }}</span>
                </div>
                <div class="col-span-1 text-left">
                    <jet-label class="col-span-6" value="Estado"/>
                    <span class=" text-white text-sm break-all">{{ customer.address.state }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import JetLabel from "../../Jetstream/Label.vue";

export default {
    components: {JetLabel},
    props: ['customer']
}


</script>
